import { Injectable } from '@angular/core';

@Injectable()
export class DynamicTranslationService {
  private translations: Object = new Object();

  public translate(key: string, text?: string): string {
    if (text) {
      this.translations[key] = text;
    }
    return this.translations[key] || key;
  }
}
